<template>
  <header>
    <template v-if="profile || $route.meta.navbar !== false">
      <b-navbar toggleable="lg" type="dark" variant="dark">
        <b-navbar-brand to="/">Time Change</b-navbar-brand>

        <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

        <b-collapse id="nav-collapse" is-nav>

          <b-navbar-nav v-if="profile && profile.role && profile.role.name === 'Authenticated'">
            <b-nav-item to="/airport-operations">Airport Operation</b-nav-item>
            <b-nav-item to="/upload-data">Upload Data</b-nav-item>
            <b-nav-item to="/convert">Convert Data</b-nav-item>
            <b-nav-item to="/collection">Collection</b-nav-item>
            <b-nav-item to="/admin">Admin</b-nav-item>
          </b-navbar-nav>
          <b-navbar-nav v-if="profile && profile.role && profile.role.name === 'Airport-Assistance'">
            <b-nav-item to="/airport-operations">Airport Operation</b-nav-item>
          </b-navbar-nav>
          <b-navbar-nav class="ml-auto">
            <b-nav-item v-if="profile" @click="logout">Logout ({{ profile.email }})</b-nav-item>
            <b-nav-item v-else :to="{ name: 'login' }">Login</b-nav-item>
          </b-navbar-nav>
        </b-collapse>
      </b-navbar>
    </template>
  </header>
</template>

<script setup>
import { inject } from 'vue'
const { profile, logout } = inject('user')
</script>
